import { render, staticRenderFns } from "./SelectBuyerType.vue?vue&type=template&id=3061f93c&"
import script from "./SelectBuyerType.vue?vue&type=script&lang=ts&"
export * from "./SelectBuyerType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3061f93c')) {
      api.createRecord('3061f93c', component.options)
    } else {
      api.reload('3061f93c', component.options)
    }
    module.hot.accept("./SelectBuyerType.vue?vue&type=template&id=3061f93c&", function () {
      api.rerender('3061f93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectBuyerType.vue"
export default component.exports